<template>
    <div class="main_data_div no-border" style="margin: 0 auto; text-align: center;" v-if="loading">
        <img src="/pic/loading-4.gif">
    </div>

    <div class="main_data_div no-border" v-else>
      <div class="col-md-12  scroll-box-contact"  v-if="localReminderHistory && localReminderHistory.length > 0">
        <div class="row"  v-for="(reminder) in  localReminderHistory">
            <reminder-single-view
                :key="reminder.contact_history_id"
                :remind-single = "reminder"
                :item-id = "itemId"
            ></reminder-single-view>
            <hr/>
        </div>
      </div>
<!--        <div class="col-md-12" v-else><div class="row" >No Contact Attempts Added</div></div>-->
            <div class="col-md-12"   style="padding: 0px;">
                    <div class="col-md-12" style="padding: 0px; margin-bottom: 10px;">
                        <div class="row"  style="padding: 0px;">
                            <div class="col-md-1" style="margin-bottom: 10px;">
                                <img :src="userCustome ? userCustome.avatar : ''" width="30">
                            </div>
                            <div class="col-md-9" style="line-height: 30px;">
                                <span ><b>{{userCustome ?  userCustome.username : ''}}</b></span>
                            </div>
                            <div class="col-md-12">
                                <textarea class="form-control" name="comment"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

            <div class="col-md-12 form-group send-notification" style="padding: 0; ">
                <label class="col-md-2 col-xs-6" style="padding: 0; margin:10px 0px;">Send as email</label>
                <div class="material-switch material-switch-job" style="margin-top: 10px">
                    <input id="send_email" type="checkbox" value="1" name="send_email" checked>
                    <label for="send_email" class="label-default" @click="checkedEmailtemplate()"></label>
                </div>
            </div>

            <div class="col-md-12 email_message"
                 style="padding:5px;border-radius: 12px !important;cursor: pointer; border:1px solid #e5e6e7; margin-bottom: 10px;"
                 v-show="emailTemplateChecked">
                <div class="ibox inner-message" style="margin: 0px">
                    <div :data-target="`#forms_template_email_toggle_${itemId}`"
                         @click="collapseAndExtendEmailtemplate()"
                         class="ibox-title"
                         style="padding: 0; margin: 0"
                         >
                        <div class="ibox-title collapsed" data-toggle="collapse" data-target="#email_panel">
                            <h5>Edit email message</h5>
                            <div class="ibox-tools">
                                <a class="" role="button">
                                    <i class="fa fa-chevron-up" style="color: #2E4051" ref="toggleIcon"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div :id="`forms_template_email_toggle_${itemId}`" v-show="collapsedEmailTemplate" v-if="getTemplateEmailAttempAccount && getTemplateEmailAttempAccount['data']">
                    <div id="email_panel" class="ibox-collapse ibox-content">
                            <div class="col-md-12 message-field">
                              <tinymce :id="`email_message11`" v-model="emailTemplateData" :placeholder="emailTemplateData" :name="`email_message11`">
                                {{emailTemplateData }}
                              </tinymce>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="getTemplateSmsAttempAccount && getTemplateSmsAttempAccount.twilioAccountInfo">
            <div class="col-md-12 form-group send-notification" style="padding: 0; ">
                <label class="col-md-2 col-xs-6" style="padding: 0; margin:10px 0px;">Send as sms</label>
                <div class="material-switch material-switch-job"  style="margin-top: 10px">
                    <input id="send_sms" type="checkbox" value="1" name="send_sms" checked>
                    <label for="send_sms" class="label-default"  @click="checkedSmstemplate()"></label>
                </div>
            </div>

            <div class="col-md-12 sms_message"
                 style="padding:5px;border-radius: 12px !important;cursor: pointer; border:1px solid #e5e6e7; margin-bottom: 10px;"
                 v-show="smsTemplateChecked">
                <div class="ibox inner-message" style="padding: 0px; margin:0px;">
                    <div class="ibox-title"  @click="collapseAndExtendSmsTemplate()" style="border-width: 0px !important;">
                        <h5>Edit SMS message</h5>
                        <div class="ibox-tools">
                            <a class="" role="button">
                                <i class="fa fa-chevron-up" style="color: #2E4051" ref="toggleIconSms"></i>
                            </a>
                        </div>
                    </div>
                    <div id="sms_panel" class="ibox-collapse ibox-content"  style="padding: 0px; margin: 0px;" v-show="collapsedSmsTemplate">
                        <div class="col-md-12 message-field">
                            <textarea id="sms_message" name="sms_message" rows="5" class="form-control">{{getTemplateSmsAttempAccount.smsMessage}}</textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import {EventBus} from "@/events/event-bus";
import {iSMobileDevice} from "@/events/sharedMethods";
import {addReminderView} from "@/modules/Booking/api/contactReminder/";
import {getReminders} from "@/modules/Booking/api/contactReminder/";


export default {
    name: "reminderAddView",
    props: {
        itemId:'',

    },
    data() {
        return {
            localReminderHistory: [],
            id: 'email_message',
            name:'email_message',
            emailTemplateChecked: true,
            collapsedEmailTemplate: false,
            smsTemplateChecked: true,
            collapsedSmsTemplate: false,
            userCustome:'',
            getTemplateEmailAttempAccount: null,
            emailTemplateData: '',
            getTemplateSmsAttempAccount: '',
            loading:true,
        }
    },

    mounted() {
        this.initiateListeners();
    },
    methods: {
        initiateListeners() {
            EventBus.$on('onDeletedReminder', remindId => {
                this.localReminderHistory =  this.localReminderHistory.filter(
                    (item) => item.contact_history_id != remindId
                );
            });

            EventBus.$on('viewModal', id => {
               if(id == this.itemId){
                   this.getRemindersList(id);
               }
            })


            EventBus.$on('addOnModel', (ReminderHistoryData, item_id) => {
                if(item_id == this.itemId){
                    this.localReminderHistory = [...ReminderHistoryData];
                }
            });

        },
        checkedEmailtemplate() {
            if(this.emailTemplateChecked){
                this.hideEmailtemplateChecked();

            }else{
                this.showEmailtemplateChecked();
            }
        },
        hideEmailtemplateChecked() {
            this.emailTemplateChecked = false;
        },
        showEmailtemplateChecked() {
            this.emailTemplateChecked = true;
        },

        collapseAndExtendEmailtemplate() {
            if(this.collapsedEmailTemplate){
                this.collapseEmailtemplate();

            } else{
                this.expandEmailtemplate();
            }
        },
        collapseEmailtemplate() {
            this.collapsedEmailTemplate = false;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')
        },
        expandEmailtemplate() {
            this.collapsedEmailTemplate = true;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')

        },
        getRemindersList(id){
            getReminders(id, 'full').then(response => {
                this.localReminderHistory =   response.data.reminder_history;
                this.userCustome = response.data.userCustome;
                this.getTemplateEmailAttempAccount = response.data.getTemplateEmailAttempAccount;
                this.getTemplateSmsAttempAccount = response.data.getTemplateSmsAttempAccount;
                this.loading=false;
            });
        },

        checkedSmstemplate() {
            if(this.smsTemplateChecked){
                this.hideSmstemplateChecked();

            }else{
                this.showSmstemplateChecked();
            }
        },
        hideSmstemplateChecked() {
            this.smsTemplateChecked = false;
        },
        showSmstemplateChecked() {
            this.smsTemplateChecked = true;
        },

        collapseAndExtendSmsTemplate() {
            if(this.collapsedSmsTemplate){
                this.collapseSmsTemplate();

            } else{
                this.expandSmsTemplate();
            }
        },
        collapseSmsTemplate() {
            this.collapsedSmsTemplate = false;
            $(this.$refs.toggleIconSms).toggleClass('rotate-180')
        },
        expandSmsTemplate() {
            this.collapsedSmsTemplate = true;
            $(this.$refs.toggleIconSms).toggleClass('rotate-180')

        },

    },
    watch: {
      getTemplateEmailAttempAccount(newVal) {
        if (newVal && newVal['data']) {
          this.emailTemplateData = newVal['data'];
        }
      }
    }
}


</script>

<style scoped>
.location_icon_section_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H4 */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
}
.scroll-box-contact{
    padding: 0px 15px;
    max-height: 100px;
    overflow: auto;
    overflow-y: scroll;
}
.ibox-title{
    border-style: none;
}
textarea.form-control{
    height: auto !important;
}
.rotate-180 {
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
    display: inline-block;
}
@media (max-width: 768px) {
    .no-border{
        border:  0px solid #000;
    }
}
</style>